import { useParams } from 'react-router-dom';

import type { Nullable } from '~/types/generics';

export default function useTargetClanId(currentAccountClanId: Nullable<number> = null) {
  const { clanId: clanIdParam } = useParams<{ clanId?: string }>();

  const externalClanId = clanIdParam ? parseInt(clanIdParam, 10) : null;
  const accountClanId = currentAccountClanId;

  const clanId = externalClanId || accountClanId || null;
  const isOwnClanBase = !externalClanId && !!accountClanId;

  return { clanId, isOwnClanBase };
}
